/**
 *
 * SurveyContext
 * Responsible for holding answers.
 *
 */

import React from 'react';

const SurveyContext = React.createContext({
  answers: {},
  error: [],
  isComplete: false,
  onAnswerChange: () => {},
  onMatrixChange: () => {},
  onMatrixCheckboxChange: () => {},
  onCheckboxChange: () => {},
  onActionClick: () => {},
});

export default SurveyContext;
